import React, { useEffect, useMemo, useState } from "react";
import { ActionButton } from "../components/action-button";
import "../calculator.scss";
import { Nest } from "../components/block-content/nest";
import classNames from "classnames";
import { isChromeLatest } from "../utils/utils";

const Calculator = () => {
  const [processHrs, setProcessHours] = useState<number>(3);
  const [timesPerWeek, setTimesPerWeek] = useState<number>(10);
  const [percentage, setPercentage] = useState<number>(100);
  const [hourly, setHourly] = useState<number>(75);
  const [quote, setQuote] = useState<number>(30000);

  const [costPerYear, setCostPerYear] = useState<number>(0);
  const [hrsPerYear, setHrsPerYear] = useState<number>(0);
  const [paysInMonths, setPaysInMonths] = useState<number>(0);
  // const firstValid = useMemo(() => first.length > 0, [first]);

  const calculateCost = () => {
    const actualProcessHrs = processHrs * (percentage * 0.01);
    const workDaysInMonth = 23;
    const timesPerDay = timesPerWeek / 5;

    const hoursPerWeek = actualProcessHrs * timesPerWeek;
    const hoursPerMonth = timesPerDay * actualProcessHrs * workDaysInMonth;
    const hoursPerYear = hoursPerMonth * 12;

    const costPerMonth = hoursPerMonth * hourly;
    const costPerYear = hoursPerYear * hourly;

    setCostPerYear(costPerYear);
    setHrsPerYear(hoursPerYear);

    if (quote > 0) {
      const paysForItselfInMonths = quote / costPerMonth;
      setPaysInMonths(paysForItselfInMonths);
    } else {
      setPaysInMonths(0);
    }
  };

  const updateNumber = (value: number, type: "hrs" | "dollars") => {
    let strValue = "";
    if (type === "hrs") {
      strValue = value.toLocaleString() + "hrs";
    } else if (type === "dollars") {
      value = typeof value !== "number" ? parseInt(value) : value;
      strValue = "$" + value.toLocaleString();
    }
    return strValue;
  };

  const salarayToYears = (value: number) => {
    const averageSalary = 50000;
    const yrs = value / averageSalary;
    if (yrs < 0.5) {
      return "half the year.";
    } else if (yrs < 1.5) {
      return "all year.";
    } else {
      return `for ${Math.round(yrs)} years.`;
    }
  };

  const processHrsPretty = useMemo(
    () => updateNumber(processHrs, "hrs"),
    [processHrs],
  );
  const hourlyRatePretty = useMemo(
    () => updateNumber(hourly, "dollars") + "/hr",
    [hourly],
  );
  const quotePretty = useMemo(() => updateNumber(quote, "dollars"), [quote]);

  useEffect(() => {
    calculateCost();
  }, [processHrs, timesPerWeek, percentage, hourly, quote]);

  return (
    <div
      className={classNames("calculator-form--meta--wrapper", {
        // "calculator-form--meta--wrapper-chrome": isChromeLatest(),
      })}
    >
      <div className="calculator-form--wrapper">
        <div className="calculator-form--group">
          <div className="calculator-form--item">
            <h4>How many hours this soul-sucking task takes:</h4>
            <div className="calculator-input-slider-combo">
              <div>
                <input
                  name="hrsPerWeek"
                  value={processHrs}
                  onChange={(e) => {
                    setProcessHours(e.target.value);
                  }}
                  type="number"
                  title="Hours Per Week"
                  min={0}
                />
                <label className="dispaly-value">{processHrsPretty}</label>
              </div>
              <input
                type="range"
                min="1"
                max="25"
                value={processHrs}
                className="slider"
                onChange={(e) => setProcessHours(e.target.value)}
              ></input>
            </div>
            <span>Average duration. Might be 1 hour. Might be 5 hours.</span>
          </div>
          <div className="calculator-form--item">
            <h4>How many times your team repeats this weekly:</h4>
            <div className="calculator-input-slider-combo">
              <div>
                <input
                  name="hrsPerWeek"
                  value={timesPerWeek}
                  onChange={(e) => setTimesPerWeek(e.target.value)}
                  type="number"
                  title="Hours Per Week"
                  min={0}
                />
                <label className="dispaly-value">{timesPerWeek}</label>
              </div>
              <input
                type="range"
                min="1"
                max="50"
                value={timesPerWeek}
                className="slider"
                onChange={(e) => setTimesPerWeek(e.target.value)}
              ></input>
            </div>
            <span>
              If it's a fire drill project, use your busy-season average.
            </span>
          </div>
          <div className="calculator-form--item">
            <h4>Average fully-loaded hourly cost:</h4>
            <div className="calculator-input-slider-combo">
              <div>
                <input
                  value={hourly}
                  onChange={(e) => setHourly(e.target.value)}
                  type="number"
                  title="Hours Per Week"
                  min={0}
                />
                <label className="dispaly-value">{hourlyRatePretty}</label>
              </div>
              <input
                type="range"
                min="1"
                max="500"
                value={hourly}
                className="slider"
                onChange={(e) => setHourly(e.target.value)}
              ></input>
            </div>
            <span>
              Most post-production teams land between $60-$150/hr. (salary +
              overhead)
            </span>
          </div>
          <div className="calculator-form--item">
            <h4>Your Hyper Brew build quote:</h4>
            <div className="calculator-input-slider-combo">
              <div>
                <input
                  value={quote}
                  onChange={(e) => setQuote(e.target.value)}
                  type="number"
                  title="Hours Per Week"
                  min={0}
                />
                <label className="dispaly-value">{quotePretty}</label>
              </div>
              <input
                type="range"
                min="10000"
                max="90000"
                value={quote}
                className="slider"
                onChange={(e) => setQuote(e.target.value)}
              ></input>
            </div>
            <span>
              Your one-time quote from Hyper Brew ( typically $20k - $80k on
              average)
            </span>
          </div>
        </div>
        {/* <div className="calculator-form--item">
              <h3>Percentage</h3>
              <input
                name="percentage"
                value={percentage}
                onChange={(e) => setPercentage(e.target.value)}
                type="number"
                min={1}
                max={100}
                title="Percentage"
              />
              <span>How much of the process can be automated?</span>
            </div>  */}
      </div>
      <div className="calculator-divider">
        <div></div>
      </div>
      <div className="calculator-form--wrapper">
        <div className="calculator-form--results--wrapper">
          <div className="calculator-form--results--before">
            <h3>What this task really costs you:</h3>
            <h1 className="calc-stat-number">
              ${Math.round(costPerYear).toLocaleString()} / year
            </h1>
            <span>
              {Math.round(hrsPerYear).toLocaleString()} hours of senior team
              time to babysit a task your tools should handle.
            </span>
            <span>
              That's like paying a full-time editor to copy-paste{" "}
              {salarayToYears(costPerYear)}
            </span>
          </div>

          <div className="calculator-form--results--after">
            <h3>What happens with a custom tool:</h3>
            <h1 className="calc-stat-number">
              Pays for itself in {paysInMonths.toFixed(1)} months
            </h1>
            <span>
              Then this one plugin saves you $
              {Math.round(costPerYear).toLocaleString()} every year after that.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calculator;
